import { render } from "./WalletExchangeSummaryCard.vue?vue&type=template&id=c0a1d052&scoped=true"
import script from "./WalletExchangeSummaryCard.vue?vue&type=script&lang=js"
export * from "./WalletExchangeSummaryCard.vue?vue&type=script&lang=js"

import "./WalletExchangeSummaryCard.vue?vue&type=style&index=0&id=c0a1d052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a1d052"]])

export default __exports__